import styled from 'styled-components'
import Icon from './Icon'

const SearchIcon = styled(Icon).attrs({
  type: 'search',
})``

export default SearchIcon
